var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalTemplate",
    {
      attrs: {
        isOpen: _vm.isOpen,
        "on-close": _vm.onModalClose,
        modalMainContainerClass: "squidLevelsModal",
        closeBtnClass: "modal_close_btn_left",
        closeIcon: "chevron-left",
        title: _vm.$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.TITLE")
      }
    },
    [
      _c("div", { staticClass: "orderSummaryContainer" }, [
        _c("div", {}, [
          _c("div", {}, [
            _c(
              "p",
              { staticClass: "font_regular text_black_secondary font_500" },
              [
                _vm._v(
                  "\n                  " +
                    _vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.HEADER.LABEL")) +
                    "\n                  " +
                    _vm._s(_vm.cart.summary.order_id) +
                    "\n              "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: " mt_12" },
          _vm._l(_vm.cart.order_items, function(item, index) {
            return _c("ItemCard", {
              key: index,
              attrs: {
                item: item,
                cart: _vm.cart,
                isDivider: _vm.cart.order_items.length - 1 !== index,
                isPreview: true
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("hr", { staticClass: "section_divider" }),
        _vm._v(" "),
        _c("section", {}, [
          _c("h2", { staticClass: "font_regular font_600 text_16" }, [
            _vm._v(_vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.LABEL")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payment_container mt-12" }, [
            _c("div", { staticClass: "pay_item" }, [
              _c("div", { staticClass: "font_regular font_500 text_14" }, [
                _vm._v(_vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font_regular font_500 text_14" }, [
                _vm._v(_vm._s(_vm.cart.summary.sumTotal.toFixed(2)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pay_item mt_8" }, [
              _c("div", { staticClass: "font_regular font_500 text_14" }, [
                _vm._v(_vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.SST")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font_regular font_500 text_14" }, [
                _vm._v(_vm._s(_vm.cart.summary.sst.toFixed(2)))
              ])
            ]),
            _vm._v(" "),
            _vm.selectedModeItem
              ? _c("div", { staticClass: "pay_item mt_8" }, [
                  _c("div", { staticClass: "font_regular font_500 text_14" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.$t(
                            "CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DELIVERY_FEE"
                          )
                        ) +
                        "\n                  "
                    ),
                    _c("span", { staticClass: "text_black_secondary" }, [
                      _vm._v(_vm._s(_vm.selectedModeItem.title))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "font_regular font_500 text_14" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          (_vm.merchant.paid_by_customer
                            ? _vm.selectedModeItem.amount
                            : 0
                          ).toFixed(2)
                        ) +
                        "\n              "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.coupon.discount
              ? _c("div", { staticClass: "pay_item mt_8" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "font_regular font_500 text_14 discount_label"
                    },
                    [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$t(
                              "CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DISCOUNT"
                            )
                          ) +
                          "\n                  "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "font_regular font_500 text_14 text_success"
                    },
                    [_vm._v("- " + _vm._s(_vm.coupon.discount))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "divider mt_8 mb_8" }),
            _vm._v(" "),
            _c("div", { staticClass: "pay_item mt_8" }, [
              _c("div", { staticClass: "font_regular font_600 text_16" }, [
                _vm._v(
                  _vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL_PAY"))
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "font_regular font_600 text_14 total_pay" },
                [
                  _vm._v(
                    "\n                  " +
                      _vm._s(_vm.calculateGrantTotal.toFixed(2)) +
                      "\n              "
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "section_divider" }),
        _vm._v(" "),
        _c("section", { staticClass: "coupon_check" }, [
          _c("label", { staticClass: "input_field" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("CATELOGUE_ORDER_PAYMENT.PROMO_CODE.LABEL")) +
                "\n          "
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.promo.promo_code,
                  expression: "promo.promo_code"
                }
              ],
              staticClass: "font_regular mt_4 font_500 text_14 mb_0 promo_code",
              staticStyle: { border: "none" },
              attrs: {
                type: "text",
                placeholder: _vm.$t(
                  "CATELOGUE_ORDER_PAYMENT.PROMO_CODE.PLACEHOLDER"
                )
              },
              domProps: { value: _vm.promo.promo_code },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.promo, "promo_code", $event.target.value)
                  },
                  _vm.clearCouponCheck
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "coupon_btn" },
              [
                _c(
                  "shop-button",
                  {
                    attrs: {
                      className: "mx-auto",
                      disabled: !_vm.promo.promo_code,
                      isLoading: _vm.uiFlags.isFetching
                    },
                    on: { click: _vm.onCheckCoupon }
                  },
                  [_vm._v("\n              Check\n              ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.coupon_err_message
              ? _c("p", { staticClass: "error" }, [
                  _vm._v(_vm._s(_vm.coupon_err_message))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "section_divider" }),
        _vm._v(" "),
        _vm.selectedModeItem
          ? _c("section", {}, [
              _c("label", { staticClass: "input_field text_14" }, [
                _c(
                  "div",
                  { staticClass: "deliveryOptionLabel input_field text_14" },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.$t(
                            "CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DELIVERY_MODE"
                          )
                        ) +
                        "\n                  "
                    ),
                    _c("span", { staticClass: "text_black_secondary" }, [
                      _vm._v(
                        "\n                      " +
                          _vm._s(
                            _vm.$t(
                              "CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.DISTANCE"
                            )
                          ) +
                          "\n                      " +
                          _vm._s(_vm.selectedModeItem.distant) +
                          " Km\n                  "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "delivery_mode" }, [
                  _c("div", [
                    _c(
                      "h3",
                      { staticClass: "font_regular font_600 text_16 mb_0" },
                      [_vm._v(_vm._s(_vm.selectedModeItem.title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "font_regular font_500 text_14 text_black_secondary"
                      },
                      [
                        _vm._v(
                          "\n                          " +
                            _vm._s(
                              _vm.$t(
                                "CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.ESTIMATED_TIME"
                              )
                            ) +
                            "\n                          "
                        ),
                        _c("span", { staticClass: "ml_8" }, [
                          _vm._v(_vm._s(_vm.selectedModeItem.time))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.merchant.paid_by_customer
                          ? _vm.selectedModeItem.amount
                          : 0
                      )
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedModeItem
          ? _c("hr", { staticClass: "section_divider" })
          : _vm._e(),
        _vm._v(" "),
        _c("section", {}, [
          _c("label", { staticClass: "input_field remark" }, [
            _vm._v(
              "\n              " +
                _vm._s(_vm.$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.REMARK")) +
                "\n              "
            ),
            _c("div", { staticClass: "mt_8 text_14" }, [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.cart.remark) +
                  "\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "shop-button",
              {
                attrs: {
                  className: "mx-auto",
                  isLoading: _vm.isLoading,
                  disabled: _vm.isLoading || _vm.isCreateBtnDisable
                },
                on: { click: _vm.onConfirm }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.SUBMIT_BTN")
                    ) +
                    "\n          "
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }